<script setup lang="ts">
import { StarFilled } from '@ant-design/icons-vue'
import { useCoursesStore } from '~~/stores/courses'
import { type BreadcrumbType } from '~~/types/global'

const { $currencyFormat } = useNuxtApp()
const { addCdnToUrl } = useFormatUrlCdn()
const coursesStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => coursesStore?.state?.courseDetail)
const courseReview = computed(() => coursesStore?.state?.courseReview)

const emits = defineEmits(['preview'])

const colors = ['blue', 'pink', 'green', 'red', 'purple', 'orange']

const breadcrumb = reactive<BreadcrumbType[]>([
  {
    path: '/',
    active: false,
    label: 'Beranda'
  },
  {
    path: `/kategori/${courseDetail.value?.data?.category?.serial}`,
    active: false,
    label: courseDetail.value?.data?.category?.name ?? '-'
  },
  {
    path: '',
    active: true,
    label: courseDetail.value?.data?.title ?? '-'
  }
])

const previewThumbnail = ref<boolean>(false)

watch(
  () => previewThumbnail.value,
  (newVal) => {
    emits('preview', newVal)
  }
)

watch(
  () => courseDetail?.value,
  (newVal) => {
    breadcrumb[breadcrumb.length - 1].label =
      newVal?.data?.category?.name ?? '-'
  }
)
</script>

<template>
  <header id="kursus-detail__banner" class="kursus-detail__banner">
    <div class="container">
      <a-row :gutter="24">
        <a-col :xs="24" :sm="16" :md="17">
          <nav>
            <AtomsBreadcrumbs :breadcrumbs="breadcrumb" />
          </nav>

          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="18">
              <div class="kursus-detail__banner-thumbnail banner-image__mobile">
                <img
                  loading="lazy"
                  :src="addCdnToUrl(courseDetail?.data?.thumbnailURL)"
                  :alt="courseDetail?.data?.title ?? '-'"
                />

                <div
                  v-if="courseDetail?.data?.videoPreviewAttachmentMetadata"
                  class="thumbnail-overlay"
                >
                  <div
                    class="thumbnail-overlay__icon"
                    @click.prevent="previewThumbnail = true"
                  >
                    <PlayCircleFilled />
                  </div>
                </div>
              </div>

              <ul
                v-if="courseDetail?.data?.tags?.length"
                class="kursus-detail__banner-tags"
              >
                <li v-for="tag in courseDetail?.data?.tags" :key="tag.serial">
                  <a-tag
                    :color="
                      colors[Math.floor(Math.random() * colors.length) + 1]
                    "
                  >
                    {{ tag?.name ?? '-' }}
                  </a-tag>
                </li>
              </ul>

              <h1 class="kursus-detail__banner-title">
                {{ courseDetail?.data?.title ?? '-' }}
              </h1>
            </a-col>
          </a-row>

          <a-row class="mt-2 sm:mt-4" :gutter="24">
            <a-col :xs="4" :sm="3">
              <p class="kursus_detail__banner-rate">
                <StarFilled />
                {{ courseReview?.data?.summary.average }}
              </p>
            </a-col>
            <a-col :xs="20" :sm="21">
              <p class="kursus_detail__banner-learners">
                <UserOutlined />
                {{ $currencyFormat(courseDetail?.data?.learnerCount ?? 0) }}
                peserta terdaftar
              </p>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>

    <ClientOnly>
      <LazyAtomsModal
        v-model:visible="previewThumbnail"
        :width="788"
        class="preview-player-mobile"
        centered
        :closable="false"
        @cancel="previewThumbnail = false"
      >
        <div class="preview-player-mobile__content">
          <a-spin class="preview-player-mobile__preload" size="large" />
          <div id="jwplayercontent" />
        </div>
      </LazyAtomsModal>
    </ClientOnly>
  </header>
</template>

<style lang="scss">
@use './styles.scss';
</style>
